import { render } from "./MultiTextArea.vue?vue&type=template&id=53e850cc"
import script from "./MultiTextArea.vue?vue&type=script&lang=js"
export * from "./MultiTextArea.vue?vue&type=script&lang=js"

import "./MultiTextArea.vue?vue&type=style&index=0&id=53e850cc&lang=scss"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__